import axios from "axios";
import { CategoryProduct } from "../entities/CategoryProduct";

const API_URL = `${process.env.REACT_APP_API_URL}products`;

export const fetchCategory = async (): Promise<CategoryProduct[]> => {
    const response = await axios.get(API_URL); // Use axios to make the GET request.
    const data = response.data.data; // Access the nested 'data' array.
    
    // Map the response to Category Product instances.
    return data.map((item: any) => new CategoryProduct(item.id, item.category, item.slug, item.is_price, item.short_description, item.long_description, item.background_image, item.banner_products, item.products, item.benefits));
}